import React, { useState } from 'react';

const Header = () => {
  const [isNavOpen, setIsNavOpen] = useState(false);
  
  const sections = ["expertise", "agent", "demo", "contact"];

  const toggleNav = () => {
    setIsNavOpen(!isNavOpen);
  };

  const navClassName = `site-nav${isNavOpen ? ' is-open' : ''}`;

  return (
    <header>
      <div className="container nav">
        <a className="brand" href="#top" aria-label="Ilmium — Home">
          <img
            src={process.env.PUBLIC_URL + "/darklogo.svg"}
            alt="Ilmium"
            decoding="async"
            loading="eager"
          />
        </a>
        
        <nav
          id="site-nav"
          className={navClassName}
          role="navigation"
          aria-label="Primary"
          data-open={isNavOpen}
        >
          {sections.map((section) => (
            <a
              key={section}
              href={`#${section}`}
              onClick={() => setIsNavOpen(false)}
            >
              {section.charAt(0).toUpperCase() + section.slice(1)}
            </a>
          ))}
        </nav>
        
        <button
          className="mobile-toggle"
          id="menuBtn"
          aria-controls="site-nav"
          aria-expanded={isNavOpen}
          onClick={toggleNav}
        >
          Menu
        </button>
      </div>
    </header>
  );
};

export default Header;
